(() => {
    "use strict";
    var e, t = {
            300: (e, t, n) => {
                var i = n(329),
                    r = n(699),
                    s = n(137),
                    o = n(610),
                    a = n(991),
                    c = n(156),
                    l = n(757),
                    u = n.n(l),
                    p = n(740),
                    d = n(669),
                    v = n.n(d),
                    h = function() {
                        function e() {
                            (0, o.Z)(this, e), (0, c.Z)(this, "selectors", {
                                wrapper: "[data-product-engraving]",
                                option: "[data-product-engraving-option]",
                                textInput: "[data-product-engraving-text]",
                                stoneInput: '[data-product-engraving-text="stone"]',
                                primaryText: "[data-product-engraving-primary-text]",
                                fontInput: "[data-product-engraving-font]",
                                logos: "[data-product-engraving-logos]",
                                logo: "[data-product-engraving-logo]",
                                logoSlide: "[data-product-engraving-logo-slide]",
                                logoSlideTpl: "#EngravingLogoSlideTemplate",
                                formAtcWrapper: ".product-form__payment-container",
                                formAtcBtn: ".ProductForm__AddToCart",
                                qty: 'input[name="quantity"]',
                                preview: "[data-product-engraving-preview-wrapper]",
                                previewBtn: "[data-product-engraving-preview]",
                                previewModal: "#ProductEngravingPreviewModal",
                                previewImage: "[data-product-engraving-preview-image]",
                                customProp: ".product-engraving__prop",
                                textlineCounter: ".product-engraving__text__counter",
                                location: "[data-product-engraving-location]",
                                livePreview: "[data-product-engraving-live-preview]"
                            }), (0, c.Z)(this, "classes", {
                                initialized: "product-engraving--initialized",
                                activeOption: "product-engraving__option--active",
                                logoSlideWrapper: "product-engraving__logos__slide-wrapper",
                                hasPreview: "preview-modal--has-preview",
                                customProp: "product-engraving__prop",
                                textlineCounter: "product-engraving__text__counter",
                                atcWrapper: "product-engraving__atc",
                                atc: "Button Button--primary Button--full engraving",
                                livePreviewActive: "product-engraving__live-preview--active",
                                livePreviewLoading: "product-engraving__live-preview--loading"
                            }), (0, c.Z)(this, "elements", {
                                wrapper: document.querySelector(this.selectors.wrapper),
                                options: document.querySelectorAll(this.selectors.option),
                                textInputs: document.querySelectorAll(this.selectors.textInput),
                                stoneInput: document.querySelector(this.selectors.stoneInput),
                                fontInputs: document.querySelectorAll(this.selectors.fontInput),
                                logoInputs: document.querySelectorAll(this.selectors.logo),
                                logos: document.querySelector(this.selectors.logos),
                                formAtcWrapper: document.querySelector(this.selectors.formAtcWrapper),
                                qty: document.querySelector(this.selectors.qty),
                                preview: document.querySelector(this.selectors.preview),
                                previewBtns: document.querySelectorAll(this.selectors.previewBtn),
                                previewModal: document.querySelector(this.selectors.previewModal),
                                previewImages: document.querySelectorAll(this.selectors.previewImage),
                                livePreview: document.querySelector(this.selectors.livePreview)
                            }), (0, c.Z)(this, "hasOptionText", !1), (0, c.Z)(this, "hasOptionLogo", !1), null !== this.elements.wrapper && (this.settings = JSON.parse(this.elements.wrapper.dataset.productEngraving), this.initOptions(), this.initTextlines(), this.initLogos(), this.initLivePreview(), this.initPreview(), this.initAtc(), this.resetOptions(), this.elements.wrapper.classList.add(this.classes.initialized), console.log("[ES] Settings", this.settings))
                       
                        }
                        var t, n;
                        return (0, a.Z)(e, [{
                            key: "resetOptions",
                            value: function() {
                                var e = this;
                                document.querySelectorAll(this.selectors.customProp).forEach((function(e) {
                                    return e.remove()
                                })), this.elements.options.forEach((function(t) {
                                    return e.resetOption(t)
                                })), this.elements.wrapper.closest("form").classList.remove("disabled")
                            }
                        }, {
                            key: "resetOption",
                            value: function(e) {
                                switch (e.querySelectorAll("input").forEach((function(e) {
                                        switch (e.type) {
                                            case "text":
                                                e.value = e.defaultValue;
                                                break;
                                            case "checkbox":
                                            case "radio":
                                                e.checked = e.defaultChecked
                                        }
                                    })), e.dataset.productEngravingOption) {
                                    case "text":
                                        this.hasOptionText = !1;
                                        break;
                                    case "logo":
                                        this.hasOptionLogo = !1
                                }
                                e.classList.remove(this.classes.activeOption), this.toggleAtc()
                            }
                        }, {
                            key: "initOptions",
                            value: function() {
                                var e = this;
                                this.elements.options.forEach((function(t) {
                                    return t.querySelector('input[type="checkbox"]').addEventListener("click", (function(t) {
                                        return e.onOptionClick(t)
                                    }))
                                }))
                            }
                        }, {
                            key: "onOptionClick",
                            value: function(e) {
                              console.log('onOptionClick');
                                var t = e.target.closest(this.selectors.option);
                                switch (t.classList.toggle(this.classes.activeOption, e.target.checked), t.dataset.productEngravingOption) {
                                    case "text":
                                        this.hasOptionText = e.target.checked;
                                        break;
                                    case "logo":
                                        this.hasOptionLogo = e.target.checked
                                }
                                if (e.target.checked) {
                                    var n = t.querySelector("input[type=text]");
                                    n && n.focus()
                                } else this.resetOption(t);
                                this.toggleAtc(), void 0 === this.addOnProduct && this.fetchAddOnProduct()
                            }
                        }, {
                            key: "initAtc",
                            value: function() {
                              console.log('initAtc');
                                var e = this;
                                this.elements.atc = document.createElement("button"), this.elements.atc.type = "button", this.elements.atc.innerHTML = document.querySelector(this.selectors.formAtcBtn).innerHTML, this.elements.atc.className = this.classes.atc, this.elements.atc.addEventListener("click", (function(t) {
                                    return e.onFormSubmit(t)
                                })), this.elements.atcWrapper = document.createElement("div"), this.elements.atcWrapper.hidden = !0, this.elements.atcWrapper.className = this.classes.atcWrapper,
                                document.querySelector('.product-engraving__atc') == null ? this.elements.atcWrapper.append(this.elements.atc): '';
                                if (document.querySelector('.product-engraving__signoff') == null) {
                                    var t = document.createElement("p");
                                    t.classList.add("product-engraving__signoff"), t.innerHTML = "The selected text and artwork (if any) will be personalized as it has been entered&mdash;preserving all capitalization and punctuation. By adding this item to the cart, you are signing off on the proof as is and are authorizing this order to be processed.", this.elements.atcWrapper.append(t), this.elements.formAtcWrapper.before(this.elements.atcWrapper), document.addEventListener("product:added", this.resetOptions.bind(this))
                                }
                            }
                        }, {
                            key: "toggleAtc",
                            value: function() {
                            console.log('toggleAtc');

                                this.isActive() ? (this.elements.formAtcWrapper.hidden = !0, this.elements.atcWrapper.hidden = !1, this.settings.preview && (this.elements.preview.hidden = !1, this.elements.wrapper.dispatchEvent(new Event("mouseenter")))) : (this.settings.preview && (this.elements.preview.hidden = !0, this.elements.wrapper.dispatchEvent(new Event("mouseleave"))), this.elements.atcWrapper.hidden = !0, this.elements.formAtcWrapper.hidden = !1), this.updateLivePreview()
                            }
                        }, {
                            key: "isActive",
                            value: function() {
                                return this.hasOptionText || this.hasOptionLogo
                            }
                        }, {
                            key: "initTextlines",
                            value: function() {
                                var e = this;
                                this.elements.textInputs.forEach((function(t) {
                                    if (!(t.maxLength < 3)) {
                                        var n = document.createElement("span");
                                        n.classList.add(e.classes.textlineCounter), n.innerText = "0/".concat(t.maxLength), t.parentNode.appendChild(n), t.addEventListener("keyup", (function(t) {
                                            var n = t.target;
                                            n.parentNode.querySelector(e.selectors.textlineCounter).innerText = "".concat(n.value.length, "/").concat(n.maxLength)
                                        }))
                                    }
                                }))
                            }
                        }, {
                            key: "initLogos",
                            value: function() {
                                console.log("111Image logo");
                                var e = this;
                                //console.log("=>>>>>"+this.settings.logos);
                                this.settings.logos && v().get("https://www.musicteachernotes.net/user/test").then((function(e) {
                                  //console.log("222222" +e.data);  
                                  return e.data
                                })).then((function(t) {
                                  console.log("data info ---"+ t);
                                    
                                    for (var n = document.getElementById("EngravingLogoSlideTemplate").innerHTML, i = "", r = 0; r < t.length; r += 12) {
                                      console.log("/////////33333++++++++++++++",n)
                                        var s = '<div><div class="product-engraving__logos__slide-wrapper">';
                                      console.log("vvvvvvvvvvvvvvvvvvvvvvvv",r)
                                        // t.slice(r, r += 12).forEach((function(e) {
                                        //     var t = n;
                                        //     t = (t = (t = t.replaceAll("%LOGO_KEY%", e.key)).replaceAll("%LOGO_NAME%", e.name)).replaceAll("%LOGO_THUMBNAIL%", e.thumbnail), s += t
                                        // })), i += s += "</div></div>"
                                    }
                                    if (!document.querySelector(e.selectors.logos).classList.contains('tns-slider')) {
                                        e.elements.logos.innerHTML = i, e.elements.logoInputs = document.querySelectorAll(e.selectors.logo), e.logoSlider = (0, p.W)({
                                            container: e.selectors.logos,
                                            items: 1,
                                            loop: !1,
                                            slideBy: "page",
                                            autoplay: !1,
                                            controls: !0,
                                            controlsPosition: "bottom",
                                            controlsText: ["&lt; Previous", "Next &gt;"],
                                            navPosition: "bottom",
                                            lazyload: !0,
                                            nav: !1
                                        })
                                    }

                                }))
                            }
                        },
                        {
                            key: "initLivePreview",
                            value: function() {
                                var e, t = this;
                                this.elements.wrapper.addEventListener("mouseenter", (function(e) {
                                    t.isActive() && (console.log("[ES/LivePreview] Show live preview pane"), t.elements.livePreview.classList.add(t.classes.livePreviewActive))
                                })), this.elements.wrapper.addEventListener("mouseleave", (function(e) {
                                    console.log("[ES/LivePreview] Hide live preview pane"), t.elements.livePreview.classList.remove(t.classes.livePreviewActive)
                                })), window.addEventListener("scroll", (function(e) {
                                    var n = t.elements.wrapper.getBoundingClientRect().top - 98;
                                    t.elements.livePreview.style.top = n < 0 ? "".concat(-n, "px") : "0px"
                                })), this.elements.textInputs.forEach((function(n) {
                                    n.addEventListener("keyup", (function(n) {
                                        clearTimeout(e), e = setTimeout((function() {
                                            return t.updateLivePreview()
                                        }), 500)
                                    }))
                                })), this.elements.fontInputs.forEach((function(n) {
                                    n.addEventListener("change", (function(n) {
                                        clearTimeout(e), e = setTimeout((function() {
                                            return t.updateLivePreview()
                                        }), 500)
                                    }))
                                })), document.addEventListener("change", (function(n) {
                                    n.target.matches(t.selectors.logo) && (clearTimeout(e), e = setTimeout((function() {
                                        return t.updateLivePreview()
                                    }), 500))
                                })), this.updateLivePreview()
                            }
                        },
                        {
                            key: "updateLivePreview",
                            value: function() {
                                var e = this;
                                this.elements.livePreview.classList.add(this.classes.livePreviewLoading), this.getPreview().then((function(t) {
                                    // "OK" === t.status ? e.elements.previewImages.forEach((function(e) {
                                    //     return e.src = t.url
                                    // })) : console.log("[ES] Preview", t)
                                  console.log("[ES] Preview", t)
                                }))
                            }
                        }, 
                        {
                            key: "initPreview",
                            value: function() {
                                var e = this;
                                (this.settings.prodID || this.settings.templateId) && (this.elements.previewBtns.forEach((function(t) {
                                    return t.addEventListener("click", (function(t) {
                                        return e.onPreviewClick(t)
                                    }))
                                })), this.elements.previewImages.forEach((function(t) {
                                    return t.addEventListener("load", (function() {
                                        e.elements.previewModal.classList.add(e.classes.hasPreview), e.elements.livePreview.classList.remove(e.classes.livePreviewLoading)
                                    }))
                                })), this.elements.previewModal.querySelector('[data-action="close-modal"]').addEventListener("click", (function() {
                                    return e.elements.previewModal.classList.remove(e.classes.hasPreview)
                                })))
                            }
                        },
                          {
                            key: "onPreviewClick",
                            value: function(e) {
                                var t = this;
                                this.elements.previewModal.classList.remove(this.classes.hasPreview), this.getPreview().then((function(e) {
                                    "OK" === e.status ? t.elements.previewImages.forEach((function(t) {
                                        return t.src = e.url
                                    })) : console.log("[ES] Preview", e)
                                }))
                            }
                        }, {
                            key: "getPreview",
                            value: (n = (0, s.Z)(u().mark((function e() {
                                var t;
                                return u().wrap((function(e) {
                                    for (;;) switch (e.prev = e.next) {
                                        case 0:
                                            console.log('On Click Event : '+this.getUserSettings());
                                            console.log(this.getUserSettings());
                                            // return e.next = 2, v().post("https://www.musicteachernotes.net/user/test", this.getUserSettings(), {
                                            //     headers: {
                                            //         Accept: "application/json"
                                            //     }
                                            // }).then((function(e) {
                                            //     return e.data
                                            // })).catch((function(e) {
                                            //     return console.log("[ES] Preview", e)
                                            // }));
                                        case 2:
                                            return t = e.sent, e.abrupt("return", t);
                                        case 4:
                                        case "end":
                                            return e.stop()
                                    }
                                }), e, this)
                            }))), function() {
                                return n.apply(this, arguments)
                            })
                        }, {
                            key: "onFormSubmit",
                            value: function() {
                                var e = this;
                                
                                if (this.hasOptionText || this.hasOptionLogo) {
                                  
                                    // this.elements.wrapper.closest("form").classList.add("disabled");
                                    var t = this.getAddOnVariant();

                                   this.addToCart({
                                        items: [{
                                            id: t.id,
                                            quantity: this.elements.qty.value
                                        }]
                                    }).then((function() {
                                        e.doAddToCart(t, {})
                                       if($('#ProductEngravingOptionLogo').is(":checked")){
                                         console.log('artwork checked');
                                         document.cookie = "Artwork=checked; path=/";
                                       }
                                    }))   }
                            }
                        }, {
                            key: "doAddToCart",
                            value: function(e, t) {
       console.log('testings');
                                var n, i = this;

                                (n = document.createElement("input")).type = "hidden", n.name = "properties[_addon_vid]", n.value = e.id, n.classList.add(this.classes.customProp), this.elements.wrapper.append(n), "" !== this.settings.prodID && ((n = document.createElement("input")).type = "hidden", n.name = "properties[Preview image]", n.value = t.url, n.classList.add(this.classes.customProp), this.elements.wrapper.append(n)), Object.entries(this.getUserSettings()).forEach((function(e) {
                                    var t = (0, r.Z)(e, 2),
                                        s = t[0],
                                        o = t[1];
                                    (n = document.createElement("input")).type = "hidden", n.classList.add(i.classes.customProp), s.indexOf("left_side_textline") > -1 ? n.name = "properties[".concat(s.replace("left_side_textline", "Left side text line "), "]") : s.indexOf("right_side_textline") > -1 ? n.name = "properties[".concat(s.replace("right_side_textline", "Right side text line "), "]") : s.indexOf("textline") > -1 ? n.name = "properties[".concat(s.replace("textline", "Text line "), "]") : "primeLine" === s && !1 !== i.settings.primary_line ? n.name = "properties[Primary line]" : "font" === s ? n.name = "properties[Font]" : "location" === s ? n.name = "properties[Artwork]" : "clipart" === s ? n.name = "properties[Location]" : "stone" === s && (n.name = "properties[Engraved stone]"), n.name.length && (n.value = o, i.elements.wrapper.append(n))
                                })), document.querySelector(this.selectors.formAtcBtn).click()
                            }
                        }, 
                         {
                            key: "addToCart",
                            value: (t = (0, s.Z)(u().mark((function e(t) {
                                var n;
                              console.log('from es.js coming');
                              
                                return u().wrap((function(e) {
                                  console.log('e.next '+e.next+' e.prev '+ e.prev)
                                  // return v().post("/cart/add.js", t);
                                  //e.preventDefault();
                                    for (;;) switch (e.prev = e.next) {
                                        case 0:
                                            return e.next = 2, v().post("/cart/add.js", t);
                                        case 2:
                                            return n = e.sent, e.abrupt("return", n);
                                        case 4:
                                        case "end":
                                            return e.stop()
                                    }
                                }), e)
                            }))), function(e) {
                                return t.apply(this, arguments)
                            })
                        },
                        {
                            key: "getUserSettings",
                            value: function() {
                              // console.log('this.settings.prodID : ',this.settings.productId)
                                var e = {
                                    prodID: this.settings.prodID,
                                    templateId: this.settings.templateId
                                };
                                if (this.hasOptionText) {
                                    var t = (0, i.Z)(this.elements.textInputs).filter((function(e) {
                                        return "" !== e.value.trim() && "stone" !== e.dataset.productEngravingText
                                    }));
                                    "productEngravingTextPrefix" in this.elements.textInputs[0].dataset ? t.forEach((function(t) {
                                        e["".concat(t.dataset.productEngravingTextPrefix, "_textline").concat(t.dataset.productEngravingText)] = t.value
                                    })) : t.forEach((function(t, n) {
                                        return e["textline".concat(n + 1)] = t.value
                                    })), this.elements.stoneInput && "" !== this.elements.stoneInput.value.trim() && (e.stone = this.elements.stoneInput.value.trim()), e.primeLine = document.querySelector("".concat(this.selectors.primaryText, ":checked")).value;
                                    var n = (0, i.Z)(this.elements.fontInputs).filter((function(e) {
                                        return e.checked
                                    }));
                                    this.settings.fonts && (e.font = n.length ? n[0].value : this.elements.fontInputs[0].value)
                                }
                                var r = (0, i.Z)(this.elements.logoInputs).filter((function(e) {
                                    console.log(e.checked);
                                  console.log('e.checked');
                                    return e.checked
                                   console.log('checked Maya11'+ this.elements.logoInputs );
                                }));
                               console.log('checked Maya');
                              console.log(this.elements.logoInputs );
                                //alert(this.elements.logoInputs);
                               // this.hasOptionLogo && (e.clipart = r.length ? r[0].value : this.elements.logoInputs[0].value);
                                var s = document.querySelector("[data-product-engraving-logo]:checked");
                                let s_v;
                               if($('#ProductEngravingOptionLogo').is(":checked")){
                                console.log('Parameters'+s.getAttribute('data-variant-id')); 
                                 s_v = s.value;
                                // console.log('Parameters'+e.location);
                                }else{
                                 s_v = "";
                                }
                                return s && (e.location = s_v), e
                            }
                        },
                              
                          {
                            key: "getAddOnVariant",
                            value: function() {
                                if (void 0 === this.addOnProduct) return !1;
                                console.log("[ES] Submit", this.addOnProduct);
                              console.log("this.getUserSettings()");
                              console.log(this.getUserSettings());
                                var e = this.getUserSettings(),
                                    t = (0, i.Z)(this.elements.textInputs).filter((function(e) {
                                        return "" !== e.value.trim()
                                    })).length,
                                    n = [];
                               // var s = document.querySelector("[data-product-engraving-logo]:checked");
                               // return t && (e.clipart = s.value), e
                                return t && n.push("ENG" + t), e.clipart && n.push(t ? "ENGART" : "ENGART2"), this.addOnProduct.variants.filter((function(e) {
                                    return e.sku === n.join("-")
                                }))[0] || !1
                            }
                        }, {
                            key: "fetchAddOnProduct",
                            value: function() {
                                var e = this;
                                v().get("/products/personalization-add-on.json", {
                                    headers: {
                                        "Content-Type": "application/json",
                                        Accept: "application/json"
                                    }
                                }).then((function(t) {
                                    console.log(t), 200 === t.status && t.data.product && (e.addOnProduct = t.data.product)
                                })).catch((function(e) {
                                    return window.alert(e)
                                }))
                            }
                        }]), e
                    }();
                window.addEventListener("load", (function() {
                    new h
                }))
            }
        },
        n = {};

    function i(e) {
        var r = n[e];
        if (void 0 !== r) return r.exports;
        var s = n[e] = {
            exports: {}
        };
        return t[e](s, s.exports, i), s.exports
    }

    i.m = t, e = [], i.O = (t, n, r, s) => {
        if (!n) {
            var o = 1 / 0;
            for (l = 0; l < e.length; l++) {
                for (var [n, r, s] = e[l], a = !0, c = 0; c < n.length; c++)(!1 & s || o >= s) && Object.keys(i.O).every((e => i.O[e](n[c]))) ? n.splice(c--, 1) : (a = !1, s < o && (o = s));
                a && (e.splice(l--, 1), t = r())
            }
            return t
        }
        s = s || 0;
        for (var l = e.length; l > 0 && e[l - 1][2] > s; l--) e[l] = e[l - 1];
        e[l] = [n, r, s]
    }, i.n = e => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return i.d(t, {
            a: t
        }), t
    }, i.d = (e, t) => {
        for (var n in t) i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
        })
    }, i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), (() => {
        var e = {
            18: 0
        };
        i.O.j = t => 0 === e[t];
        var t = (t, n) => {
                var r, s, [o, a, c] = n,
                    l = 0;
                for (r in a) i.o(a, r) && (i.m[r] = a[r]);
                if (c) var u = c(i);
                for (t && t(n); l < o.length; l++) s = o[l], i.o(e, s) && e[s] && e[s][0](), e[o[l]] = 0;
                return i.O(u)
            },
            n = self.webpackChunkmittensandmax_com = self.webpackChunkmittensandmax_com || [];
        n.forEach(t.bind(null, 0)), n.push = t.bind(null, n.push.bind(n))
    })();
    var r = i.O(void 0, [736], (() => i(300)));
    r = i.O(r)
})();
